<!--招标中心-->
<template>
  <div class="black_overlar">
    <div class="tender-info-show1">
      <!-- 判断是否选择公告 -->
      <div class="tender-top" :style="tenderStyle">
        <div class="title">{{name}}</div>
        <div class="describe">{{about}}</div>
        <a href="javascrip:void(0)" @click="jumpshow(url)" class="comeTender">{{come}}</a>
        <div>
          <div class="tender-title">
            <span class="title-type">状态</span>
            <span class="center-title">标题</span>
            <span class="organize">发布组织</span>
            <span class="publish-time">发布日期</span>
          </div>
          <div class="tender-border-bottom"></div>
          <div class="tender-list">
            <div class="link"></div>
            <ul>
              <li v-for="(category,i) in categorys.slice(0,6)" :key="i">
                <a href="javascrip:void(0)" @click="jumpTos(category.noticeId)">
                  <span
                    class="status"
                    :class="addclassStatus(category.status)"
                    :title="category.status"
                  >{{category.status}}</span>
                  <span class="title-content" :title="category.noticeName">{{category.noticeName}}</span>
                  <span class="organize-content">{{category.org}}</span>
                  <span class="time-content">{{category.publish_time.substring(0,11)}}</span>
                </a>
              </li>
            </ul>
            <div class="tender-a">
              <a href="javascrip:void(0)" @click="showbut" :style="tender">查看更多</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tender-info-show2">
      <div class="notice">
        <div class="notice-title">
          <span class="c1">{{sysName}}</span>
          <a class="c2" href="javascrip:void(0)" :style="c2" @click="jumpToList()">{{sysAbout}}</a>
        </div>
        <div class="moreinfo">
          <ul>
            <li v-for="(sInfo,i) in sysInfo.slice(0,14)" :key="i">
              <a class="status" href="javascrip:void(0)" @click="jumpToDetail(sInfo.noticeId)">
                <span class="title-content" :title="sInfo.noticeName">{{sInfo.noticeName}}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let categoryShow = JSON.parse(this.$supMainPageConfig);
    this.theme = JSON.parse(this.$supMainPageConfig).catItemImg.info7.theme;
    let categoryInfo1 = JSON.parse(this.$supMainPageConfig).categoryInfoShow
      .categoryInfo1[0];
    return {
      sysName: categoryShow.sysShow.name,
      sysAbout: categoryShow.sysShow.about,
      sysUrl: categoryShow.sysShow.url,
      sysInfo: categoryShow.sysShow.info,
      sysBiztype: categoryShow.sysShow.biztype,
      show: false,
      styles: this.theme,
      showsupbody: "",
      isshow: "",
      name: categoryInfo1.category.name,
      about: JSON.parse(this.$supMainPageConfig).catItemImg.info1.about,
      come: categoryInfo1.category.come,
      url: categoryInfo1.category.url,
      biztype: categoryInfo1.category.biztype,
      categorys: categoryInfo1.info
    };
  },
  methods: {
    jumpToDetail(noticeId) {
      let param = "";
      param = "&noticeId=" + noticeId;
      const base = window.location.href.split("/isv/")[0];
      let url = base + "/index.html?formId=quo_notice" + param;
      window.open(url, "_blank");
    },
    jumpTos(noticeId) {
      let param = "";
      param = "&noticeId=" + noticeId;
      const base = window.location.href.split("/isv/")[0];
      let url = base + "/index.html?formId=ten_announcement_detail" + param;
      window.open(url, "_blank");
    },
    jumpToList() {
      this.show = true;
      this.showsupbody = false;
      this.$emit("func", this.show, this.showsupbody);
    },
    jumpshow(param) {
      window.open(param, "_blank");
    },
    jumpshows(param) {
      let url = param;
      window.open(url, "_blank");
    },
    showbut() {
      this.show = false;
      this.showsupbody = true;
      this.isshow = "招标公告";
      this.$emit("func", this.show, this.showsupbody, this.isshow);
    },
    addclassStatus(status) {
      switch (status) {
        case "招标立项":
          return "statustypea";
        case "供方入围":
          return "statustypeb";
        case "标书编制":
          return "statustypec";
        case "发标":
          return "statustyped";
        case "答疑":
          return "statustypee";
        case "开标":
          return "statustypef";
        case "评标":
          return "statustypeg";
        case "商务谈判":
          return "statustypeh";
        case "定标":
          return "statustypei";
      }
    }
  },
  computed: {
    tenderStyle: function() {
      let tenderTitleImgSrc = JSON.parse(this.$supMainPageConfig).catItemImg
        .info1.tenderTitleImgSrc;
      return {
        backgroundImage: "url(" + tenderTitleImgSrc + ")",
        backgroundRepeat: "no-repeat",
        height: "164px",
        width: "824px",
        borderRadius: "5px 5px 0px 0px"
      };
    },
    tender: function() {
      if (this.styles == 1) {
        return {
          color: " #4a98ff",
          textDecoration: "none",
          fontSize: "14px",
          float:"right",
          marginRight:"26px"
        };
      }
      if (this.styles == 2) {
        return {
          color: " #6869FB",
          textDecoration: "none",
          fontSize: "14px",
          float:"right",
          marginRight:"26px"
        };
      }
      if (this.styles == 3) {
        return {
          color: " #29C392",
          textDecoration: "none",
          fontSize: "14px",
          float:"right",
          marginRight:"26px"
        };
      }
      if (this.styles == 4) {
        return {
          color: " #FC8555",
          textDecoration: "none",
          fontSize: "14px",
          float:"right",
          marginRight:"26px"
        };
      }
    },
    c2: function() {
      if (this.styles == 1) {
        return {
          color: " #4a98ff",
          textDecoration: "none",
          float: "right"
        };
      }
      if (this.styles == 2) {
        return {
          color: " #6869FB",
          textDecoration: "none",
          float: "right"
        };
      }
      if (this.styles == 3) {
        return {
          color: " #29C392",
          textDecoration: "none",
          float: "right"
        };
      }
      if (this.styles == 4) {
        return {
          color: " #FC8555",
          textDecoration: "none",
          float: "right"
        };
      }
    }
  }
};
</script>

<style scoped lang="scss">
.black_overlar {
  width: 1200px;
  height: 533px;
  margin: 0 auto;
  display: flex;
}
.tender-info-show1 {
  float: left;
  width: 824px;
  height: 533px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  background: #ffffff;
}
.tender-top {
  display: inline-grid;
}
.tender-top .title {
  width: 168px;
  height: 56px;
  font-size: 40px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 56px;
  letter-spacing: 2px;
  margin-left: 24px;
  margin-top: 24px;
}
.tender-top .describe {
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  margin-top: 11px;
  margin-bottom: 11px;
  margin-left: 24px;
}
.tender-top .comeTender {
  height: 32px;
  width: 119px;
  margin-left: 24px;
  margin-bottom: 22px;
  background: #ffffff;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(107, 110, 131, 1);
  line-height: 32px;
  border-radius: 4px;
  text-decoration: none;
}
.tender-title {
  margin-left: 24px;
}
.tender-title span {
  width: 34px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  letter-spacing: 1px;
  font-weight: bold;
}

.tender-title span.title-type {
  margin-top: 24px;
}

.tender-title span.center-title {
  margin-left: 33px;
  margin-top: 24px;
}

.tender-title span.organize {
  margin-left: 325px;
  margin-top: 24px;
}

.tender-title span.publish-time {
  margin-left: 198px;
  margin-top: 24px;
}

.tender-border-bottom {
  margin-left: 24px;
  margin-right: 22px;
  margin-top: 22px;
  border-bottom: 1px solid #dadada;
}

.tender-list ul {
  list-style: none;
  padding-left: 24px;
}
.tender-list li {
  white-space: nowrap;
  height: 22px;
}
.tender-list li a {
  color: inherit;
}

.tender-list li a:hover {
  background-color: #f2f6fc;
}

.tender-list img {
  width: 45px;
  height: 18px;
  align-items: center;
  margin-right: 12px;
  vertical-align: top;
}
.tender-list ul li {
  height: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(41, 44, 64, 1);
  line-height: 22px;
  margin-bottom: 22px;
}

.tender-list ul li .title-content {
  width: 324px;
  padding-right: 35px;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-left: 12px;
}

.tender-list ul li .organize-content {
  width: 220px;
  padding-right: 45px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tender-list ul li .time-content {
  width: 107px;
  display: inline-block;
}

.tender-info-show2 {
  float: left;
  margin-left: 16px;
  width: 360px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.tender-info-show2 .login-option {
  height: 269px;
  margin-bottom: 16px;
  padding-left: 15px;
}

.tender-info-show2 .login-option .account span {
  padding-left: 12px;
  padding-right: 6px;
  border-right: 1px solid #dedede;
  width: 30px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(180, 188, 196, 1);
  line-height: 20px;
}

.tender-info-show2 .login-option .account input {
  margin-left: 6px;
  outline: none;
  border: 0px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 20px;
}

.tender-info-show2 .login-option .btn {
  margin-top: 20px;
}
.tender-info-show2 .login-option .btn .forget {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(180, 188, 196, 1);
  line-height: 20px;
  text-decoration: none;
  margin-left: 80px;
}
.tender-info-show2 .notice {
  height: 534px;
  padding-left: 24px;
  background: #ffffff;
}

.tender-info-show2 .notice .notice-title {
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  letter-spacing: 1px;
  border-bottom: 1px solid #dedede;
  margin-top: 19px;
  padding-bottom: 19px;
  margin-right: 24px;
  font-weight: bold;
}

.tender-info-show2 .notice .moreinfo ul {
  list-style: none;
  padding-left: 0px;
}
.tender-info-show2 .notice .moreinfo ul li {
  margin-top: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.tender-info-show2 .notice .moreinfo ul li a {
  height: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #292c40;
  line-height: 22px;
  text-decoration: none;
}

.btna {
  margin-top: 80px;
}

.quit {
  color: #000000;
  text-decoration: none;
}

.he3 {
  display: none;
  width: 312px;
  height: 18px;
  border-radius: 4px;
  text-align: center;
  font-size: 15px;
  background-color: #ffe7e4;
  color: #fd6c6a;
}

.LangSelect_container_3Q5h {
  right: 353px;
  display: flex;
  align-items: cente;
  cursor: default;
  height: 0px;
  margin-left: 260px;
  margin-top: 8px;
}

.LangSelect_icon_3wOK {
  width: 14px;
  height: 14px;
  background-size: 14px;
  margin-right: 2px;
  margin-top: 3px;
}

.LangSelect_text_VztM {
  font-size: 10px;
  color: rgb(79, 157, 255);
  line-height: 20px;
  //去掉三角
  -webkit-appearance: none;
  //去掉边框
  border: 0;
  display: block;
  //去掉下拉边框线
  outline: none;
  //去掉背景色
  background: transparent;
}

.LangSelect_container_3Q6h {
  right: 353px;
  display: flex;
  align-items: cente;
  cursor: default;
  height: 0px;
  margin-left: 260px;
  margin-top: 8px;
}

.LangSelect_icon_4wOK {
  width: 14px;
  height: 14px;
  background-size: 14px;
  margin-right: 2px;
  margin-top: 3px;
}

.statustypea {
  color: #29c392;
  border: 1px solid #29c392;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypeb {
  color: #29c392;
  border: 1px solid #29c392;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypec {
  color: #29c392;
  border: 1px solid #29c392;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustyped {
  color: #29c392;
  border: 1px solid #29c392;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypee {
  color: #29c392;
  border: 1px solid #29c392;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypef {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypeg {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypeh {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypei {
  color: #778899;
  border: 1px solid #778899;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

//过渡动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.syzcshow {
  z-index: 10;
  position: fixed;
  width: 480px;
  height: 600px;
  left: 45%;
  top: 28.5%;
  margin-left: -150px;
  margin-top: -80px;
  background-color: #ffffff;
}

.sywjshow {
  z-index: 10;
  position: fixed;
  width: 480px;
  height: 600px;
  left: 45%;
  top: 28.5%;
  margin-left: -150px;
  margin-top: -80px;
  background-color: #ffffff;
}

.syzcshowdiv {
  z-index: 10;
  position: fixed;
  left: 60.5%;
  top: 22.5%;
  font-size: 15px;
  color: #999999;
  text-decoration: none;
  font-weight: 100;
}

.syzcshowdiv:hover {
  color: #29c392;
}

.zhezhao {
  width: 100%;
  height: 100%;
  background-color: #000;
  filter: alpha(opacity=50);
  -moz-opacity: 0.5;
  opacity: 0.5;
  position: fixed;
  left: 0px;
  top: 0px;
  display: none;
  z-index: 5;
}
@media screen and ( max-width: 1200px ){
  .black_overlar {
  width: 900px;
}
.tender-info-show1 {
  width: 74%;
}

.tender-info-show2 {
  width: 26%;
}

.tender-list ul li .title-content {
  width: 190px;
}

.tender-title span.organize {
  margin-left: 190px;
}

}


</style>